import React from 'react';
import { images } from '../../../Constants/ImageUrls';
import { PlaystoreContainer, Rating, RatingName } from './styled';

export default function index() {
  return (
    <PlaystoreContainer playstore>
      <div>
        <Rating>
          4.6 <img src={images.starIcon} alt="star icon" />
        </Rating>
        <RatingName>Playstore Ratings</RatingName>
      </div>
      <div>
        <Rating>#1 Top</Rating>
        <RatingName>Trending App</RatingName>
      </div>
      <div>
        <Rating>10,00,000+</Rating>
        <RatingName>Downloads</RatingName>
      </div>
      <div>
        <Rating>10+ Million</Rating>
        <RatingName>Happy Young Parents</RatingName>
      </div>
    </PlaystoreContainer>
  );
}
